import script from "./ReservaServiciosSeleccion.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservaServiciosSeleccion.vue?vue&type=script&setup=true&lang=js"

import "./ReservaServiciosSeleccion.vue?vue&type=style&index=0&id=05a91248&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05a91248"]])

export default __exports__